import _isArray from 'lodash/isArray';
import getOpeningHoursSpecification from './openingHours';

function locationToPostalAddress(location) {
  var hours = null;
  var openedHours = location.hours.filter(function (_ref) {
    var open = _ref.open,
        close = _ref.close;
    return !!open && !!close;
  });
  var isOpenSomeDay = openedHours.length > 0;

  if (isOpenSomeDay) {
    hours = getOpeningHoursSpecification(openedHours);
  }

  return {
    '@type': 'PostalAddress',
    addressLocality: location.city,
    addressRegion: location.state,
    streetAddress: location.street,
    email: location.email,
    telephone: location.phoneNumber,
    name: location.name,
    hoursAvailable: hours
  };
}

export default (function (address) {
  var onlyPrimary = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (!address) {
    return null;
  }

  if (typeof address === 'string') {
    return address;
  }

  if (_isArray(address)) {
    if (onlyPrimary) {
      return locationToPostalAddress(address[0]);
    }

    return address.map(locationToPostalAddress);
  }

  return locationToPostalAddress(address);
});